import { TEditCategoryAction, EditCategoryActionTypes } from './editCategoryActions';
import { IEditCategoryState } from './editCategoryContext';

export const editCategoryReducer = (state: IEditCategoryState, action: TEditCategoryAction): IEditCategoryState => {
	switch (action.type) {
		case EditCategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditCategoryActionTypes.SET_ALL_DATA:
			return {
				...state,
				filePath: action.payload.filePath,
				categoryID: action.payload.categoryID,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				nameOfCategory: action.payload.nameOfCategory,
				categoryType: action.payload.categoryType,
				isRestricted: action.payload.isRestricted,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				translations: action.payload.translations,
			};
		case EditCategoryActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditCategoryActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditCategoryActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditCategoryActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditCategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
			};
		case EditCategoryActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditCategoryActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case EditCategoryActionTypes.CHANGE_NAME_OF_CATEGORY:
			return {
				...state,
				nameOfCategory: action.payload.nameOfCategory,
			};
		case EditCategoryActionTypes.SET_CATEGORY_TYPE:
			return {
				...state,
				categoryType: action.payload.categoryType,
			};
		case EditCategoryActionTypes.TOGGLE_IS_RESTRICTED:
			return {
				...state,
				isRestricted: !state.isRestricted,
			};
		case EditCategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case EditCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditCategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
